import { render, staticRenderFns } from "./location-cert-requirements-checkbox-list.vue?vue&type=template&id=0c66ee3a&"
import script from "./location-cert-requirements-checkbox-list.vue?vue&type=script&lang=js&"
export * from "./location-cert-requirements-checkbox-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports